import React from 'react';

const EmailIcon: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2951_72686)">
        <path
          d="M22.5 19.5H3.5C2.96957 19.5 2.46086 19.2893 2.08579 18.9142C1.71071 18.5391 1.5 18.0304 1.5 17.5V4.5H20.5C21.0304 4.5 21.5391 4.71071 21.9142 5.08579C22.2893 5.46086 22.5 5.96957 22.5 6.5V19.5Z"
          stroke="#333333"
        />
        <path d="M5 9.5L12 15L19 9.5" stroke="#333333" />
      </g>
      <defs>
        <clipPath id="clip0_2951_72686">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EmailIcon;
